import request from '@/util/request'

const group_name = 'tysap-web'
const api_name = 'article'


export function getNews(params) {
  return request({
    url: `/${group_name}/${api_name}/query`,
    method: 'get',
    params
  })
}


export function queryPage(params) {
  return request({
    url: `/api/newsInformation/queryPage`,
    method: 'post',
    data:params
  })
}


export function queryDetails(id) {
  return request({
    url: `/api/newsInformation/queryDetails/${id}`,
    method: 'get',
  })
}





// WEBPACK FOOTER //
// ./src/api/consult/news.js